import React, { useEffect, useState } from 'react';
import { Routes } from 'react-router-dom';

import Loader from 'Shared/Components/Loader/Loader';
import PageLoader from 'Shared/Components/PageLoader';
import Layout from 'Shared/Layouts/Layout';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';
import { ScrollToTopOnMount } from 'Shared/Utils/Scroll/Hooks/useScrollToTop';

import IRoute from '../Models/IRoute';
import RouteBuilder from '../Utils/RouteBuilder';

interface IMainRouteProps {
  appRoutes: IRoute[][][];
}

const MainRoute: React.FunctionComponent<IMainRouteProps> = (props: IMainRouteProps) => {
  const { userIsLogin } = useUserManager();
  const [showRoutes, setShowRoutes] = useState<boolean>(false);

  useEffect(() => {
    userIsLogin().then((isLogin) => {
      if (isLogin) {
        setShowRoutes(isLogin);
      }
    });
  }, []);

  return (
    <Layout>
      <React.Suspense fallback={<PageLoader />}>
        <ScrollToTopOnMount />
        {showRoutes ? <Routes>{RouteBuilder(props.appRoutes)}</Routes> : <Loader active />}
      </React.Suspense>
    </Layout>
  );
};

export default MainRoute;
